import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 60000 });

export const createOrder = async (payload) => {
  const { data } = await api.post("/orders", payload);
  return data;
};

export const createCheckoutSession = async (orderId, originUrl) => {
  const { data } = await api.post("/checkout/session", {
    order_id: orderId,
    origin_url: originUrl,
  });
  return data;
};

export const getCheckoutStatus = async (sessionId) => {
  const { data } = await api.get(`/checkout/status/${sessionId}`);
  return data;
};
